import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Layout } from 'antd';
import CategoryTree from './CategoryTree';
import NoteList from './NoteList';
import Navigation from './Navigation';
import {ALL_NOTES} from "../utils/constants";

const { Content } = Layout;



const Dashboard: React.FC = () => {
  const [selectedCategoryId, setSelectedCategoryId] = useState<number>(ALL_NOTES.id);
  const [categoryBreadcrumb, setCategoryBreadcrumb] = useState<string>('');
  const location = useLocation();
  const navigate = useNavigate();


  function getCurrentCategoryId(): number {
    let currentCategory = ALL_NOTES.id;
    const categoryId = new URLSearchParams(location.search).get('category');
    if (categoryId) {
      currentCategory = parseInt(categoryId);
    }
    return currentCategory;
  }

// Handle URL changes
  useEffect(() => {
    let currentCategory = getCurrentCategoryId();
    console.log('Current Category:', currentCategory);
    if(currentCategory !== selectedCategoryId){
      setSelectedCategoryId(currentCategory);
    }
  }, [location.search]);

  // Update URL when category is selected, but prevent recursion
  const handleCategorySelect = (categoryId: number, categoryBreadcrumb: string) => {
    const searchParams = new URLSearchParams(location.search);
    const currentCategoryId = searchParams.get('category');

    setCategoryBreadcrumb(categoryBreadcrumb);
    
    // Only update if the category actually changed
    if (currentCategoryId == null || (parseInt(currentCategoryId) !== categoryId)) {
      setSelectedCategoryId(categoryId);
      searchParams.set('category', categoryId.toString());
      // Use replace and prevent page refresh
      navigate({ search: searchParams.toString() }, { replace: true });
    }
  };

  return (
    <Layout className="min-h-screen bg-[#f5f5f5] dark:bg-[#1a1a1a]">
      <Navigation selectedCategoryId={selectedCategoryId} />
      <Content className="w-full">
        <main className="w-full max-w-full p-0 m-0 pt-24">
          <div className="flex flex-col lg:flex-row gap-6 w-full pl-2 pr-2 sm:pl-4 sm:pr-4 md:pl-8 md:pr-8">
            {/* Category Tree - Fixed height on mobile */}
            <div className="w-full lg:w-64 max-h-[300px] lg:max-h-none h-fit lg:h-auto overflow-y-auto border border-[#048ba8]/10 rounded-2xl bg-white dark:bg-[#1a1a1a] p-4">
              <CategoryTree
                onSelectCategory={handleCategorySelect}
                selectedCategoryId={selectedCategoryId}
              />
            </div>
            {/* Note List Section */}
            <div className="flex-1 flex flex-col gap-4">
              <NoteList
                selectedCategoryId={selectedCategoryId}
                categoryBreadcrumb={categoryBreadcrumb}
              />
            </div>
          </div>
        </main>
      </Content>
    </Layout>
  );
};

export default Dashboard; 